module.exports = __webpack_public_path__ + "static/image/history/m/201506@3x.jpg?fcc294f3";